import { ENVIRONMENT_GLOBAL } from './global';
//
// Set environment variables specific for all qualification servers to share
//
export const ENVIRONMENT_QUAL = {
  ...ENVIRONMENT_GLOBAL,
  auth0: {
    audience: 'https://onemedical.com',
    clientId: 'lXSBxDw7VYlmhgJyFJZ9xeMeOcCpiiUv',
    domain: 'qual-onemedical.auth0.com',
  },
  appSync: {
    apiUrl: 'https://g5cmgzifxvdvrgxu6hyuylbsom.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'us-east-1',
    enabled: true,
  },
  designSystemUrl: '/design/index.html',
  devRoutes: true,
  enableProdMode: true,
  gaAccount: 'UA-39757505-1',
  marketingSite: 'https://mktg-stage.onemedical.com',
  mixpanelDebug: true,
  mixpanelToken: '44008e1ef10bb5ecc7b4f967257c824d',
  pusherKey: '5422148b626236f6bff3',
  recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // test recaptcha key
  newRecaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // test recaptcha key
  sentry: {
    enabled: false,
    dsn: '',
    environment: '',
  },
  stripePublishableKey:
    'pk_test_517WAN8I6Upoy4vYdDY4YyNaM2bQHskzSWEzGUnoNNCJaLC15PQWK40pTvmerXur4MYXMVMCsAoi0yQPCBsAXrLNF00DrMRauN5',
  topLevelDomain: 'app.1life.com',
};
